export default __webpack_public_path__ + "static/media/Heart.ca4a793e.png";